export default "eb77a54ba4a301a8.woff2"